import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';
import { toQueryParams } from 'helpers/api';

export const supportAccessApi = createApi({
  reducerPath: 'supportAccessApi',
  baseQuery: createBaseQuery('support_access_requests'),
  endpoints: builder => ({
    getSupportAccessRequests: builder.query({
      query: params => `?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    getCompanySupportAccessRequests: builder.query({
      query: company_id => `/?company_id=${company_id}`,
      transformResponse: ({ result }) => result,
    }),
    getPendingSupportAccessRequests: builder.query({
      query: () => '/pending',
      transformResponse: ({ result }) => result,
    }),
    getActiveSupportAccessRequests: builder.query({
      query: () => '/active',
      transformResponse: ({ result }) => result,
    }),
    createSupportAccessRequest: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    cancelSupportAccessRequest: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
    }),
    grantSupportAccessRequest: builder.mutation({
      query: id => ({
        url: `/${id}/grant`,
        method: 'PUT',
      }),
      transformResponse: ({ result }) => result,
    }),
    denySupportAccessRequest: builder.mutation({
      query: id => ({
        url: `/${id}/deny`,
        method: 'PUT',
      }),
      transformResponse: ({ result }) => result,
    }),
    revokeSupportAccessRequest: builder.mutation({
      query: id => ({
        url: `/${id}/revoke`,
        method: 'PUT',
      }),
      transformResponse: ({ result }) => result,
    }),
    completeSupportAccessRequest: builder.mutation({
      query: id => ({
        url: `/${id}/complete`,
        method: 'PUT',
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useLazyGetSupportAccessRequestsQuery,
  useGetCompanySupportAccessRequestsQuery,
  useGetPendingSupportAccessRequestsQuery,
  useGetActiveSupportAccessRequestsQuery,
  useCreateSupportAccessRequestMutation,
  useCancelSupportAccessRequestMutation,
  useGrantSupportAccessRequestMutation,
  useDenySupportAccessRequestMutation,
  useRevokeSupportAccessRequestMutation,
  useCompleteSupportAccessRequestMutation,
} = supportAccessApi;
